export let state = $state({
  // path to the calendly link
  calendlyUrl: 'http://calendly.com/txtsignalmatt',

  // current view
  currentView: 'index',

  // is this the first run?
  isFirstRun: !localStorage.LaunchpadShown,
})

export function setLaunchpadShown() {
  localStorage.LaunchpadShown = true
  state.isFirstRun = false
}

export function setCurrentView(view: string) {
  state.currentView = view
}
